import React, { useMemo } from 'react';
import { FormikProps } from 'formik';

import Field from 'legacy/common/components/wysiwyg-form/Field';
import { ErrorResponse } from 'legacy/common/utils/error';
import { useCheckout } from 'features/events/checkout/context';
import Header from '../../../../../../../components/checkout/Header';
import CenteredContainer from 'components/CenteredContainer';
import { useViewEvent } from 'features/events/context/ViewEvent';
import EventInfo from '../../../EventInfo';
import Button from 'components/Button';
import TopBackgroundWrapper from 'components/checkout/TopBackgroundWrapper';
import CheckoutTimer from '../../../CheckoutTimer';
import { useTranslation } from 'react-i18next';

type Props = {
  goToTicketSelection: () => void;
  data: ReturnType<typeof useCheckout>['requestScreening']['questions'];
  error: ErrorResponse;
  isLoading: boolean;
} & FormikProps<unknown>;

const ScreeningForm = ({
  submitForm,
  values,
  goToTicketSelection,
  data,
  error,
  isLoading
}: Props) => {
  const { t } = useTranslation(['checkout']);
  const { event } = useViewEvent();
  const { user } = useCheckout();
  const totalNumberOfAnswers = useMemo(
    () => Object.values(values).filter((val) => val).length,
    [values]
  );

  return (
    <>
      <Header
        onBack={goToTicketSelection}
        title={t('checkout:screeningQuestions')}
        subtitle={event.title}
        isUserLoggedIn={!!user}
        TimerComponent={CheckoutTimer}
      />
      <TopBackgroundWrapper
        imageUrl={event.photo.url}
        hasTierNav={false}
        isUserLoggedIn={!!user}
        className="md:py-14"
      >
        <EventInfo />
      </TopBackgroundWrapper>
      <CenteredContainer hasPadding={false} wideContent>
        <div className="px-4 gap-5 md:gap-8 flex flex-col pb-10">
          <div className="max-w-[650px] mx-auto flex flex-col gap-3">
            <div className="font-normal text-sm md:text-base text-neutral-500 pb-4">
              {t('checkout:pleaseAnswerTheFollowingQuestions')}
            </div>
            {data.map((item) => (
              <>
                <Field
                  key={item._id}
                  type="text"
                  label={item.question}
                  id={`question-${item._id}`}
                  name={item._id}
                  placeholder={t('checkout:writeAnswerHere')}
                />
              </>
            ))}
            {error?.message && (
              <div className="text-error text-center pb-2">{error.message}</div>
            )}
            <Button
              variant="primaryDark"
              onClick={submitForm}
              size="large"
              loading={isLoading}
              className="w-full"
              disabled={
                totalNumberOfAnswers < data.length || Boolean(error?.message)
              }
            >
              {t('checkout:sendRequest')}
            </Button>
          </div>
        </div>
      </CenteredContainer>
    </>
  );
};

export default ScreeningForm;
